import type { IntentConfig } from "@fathom/intent";
import { resolveGuardrails } from "@fathom/intent";
import type { ProjectionContext, ProjectionOutput, ProjectionTarget } from "./types.js";
import { generateClaudeSkill } from "./templates/claude.js";
import { generateCursorRules } from "./templates/cursor.js";
import { generateSystemPrompt } from "./templates/generic.js";
import { generateCopilotInstructions } from "./templates/copilot.js";
import { generateWindsurfRules } from "./templates/windsurf.js";

const ALL_TARGETS: ProjectionTarget[] = ["claude", "cursor", "generic", "copilot", "windsurf"];

/**
 * Generate projection files from intent config.
 *
 * Returns a map of relative paths (within .fathom/) to file contents.
 * If `targets` is specified, only generates for those tools.
 */
export function generateProjections(
  intent: IntentConfig,
  context?: ProjectionContext,
  targets?: ProjectionTarget[],
): ProjectionOutput {
  const guardrails = resolveGuardrails(intent);
  const activeTargets = targets ?? ALL_TARGETS;
  const files = new Map<string, string>();

  for (const target of activeTargets) {
    switch (target) {
      case "claude":
        files.set(
          "projections/claude/SKILL.md",
          generateClaudeSkill(intent, guardrails, context),
        );
        break;
      case "cursor":
        files.set(
          "projections/cursor/.cursorrules",
          generateCursorRules(intent, guardrails, context),
        );
        break;
      case "generic":
        files.set(
          "projections/generic/SYSTEM_PROMPT.md",
          generateSystemPrompt(intent, guardrails, context),
        );
        break;
      case "copilot":
        files.set(
          "projections/copilot/copilot-instructions.md",
          generateCopilotInstructions(intent, guardrails, context),
        );
        break;
      case "windsurf":
        files.set(
          "projections/windsurf/.windsurfrules",
          generateWindsurfRules(intent, guardrails, context),
        );
        break;
    }
  }

  return { files };
}
